import { create } from 'zustand';

// Lightweight, app-wide celebration queue for newly-earned badges. Any
// completion path (dashboard, activity, course, quiz) calls celebrateBadges
// with the badge ids it just awarded; the single BadgeEarnedModal mounted in
// AppShell reveals them one at a time. Decouples "a badge was earned" from
// "which screen earned it", so every entry point celebrates identically.

export interface Milestone {
  emoji: string;
  title: string;
  subtitle?: string;
}

interface CelebrationState {
  badgeQueue: string[];
  celebrateBadges: (badgeIds: string[]) => void;
  dismissCurrentBadge: () => void;

  // Generic identity-title celebration (quest completion, future milestones).
  milestoneQueue: Milestone[];
  celebrateMilestone: (milestone: Milestone) => void;
  dismissCurrentMilestone: () => void;
}

export const useCelebrationStore = create<CelebrationState>((set) => ({
  badgeQueue: [],
  celebrateBadges: (badgeIds) => {
    if (!badgeIds || badgeIds.length === 0) return;
    set((state) => ({ badgeQueue: [...state.badgeQueue, ...badgeIds] }));
  },
  dismissCurrentBadge: () => set((state) => ({ badgeQueue: state.badgeQueue.slice(1) })),

  milestoneQueue: [],
  celebrateMilestone: (milestone) => set((state) => ({ milestoneQueue: [...state.milestoneQueue, milestone] })),
  dismissCurrentMilestone: () => set((state) => ({ milestoneQueue: state.milestoneQueue.slice(1) })),
}));
